import PropTypes from 'prop-types';

import Footer from './Footer';
import { DensityValues, TableContainer, DesktopTableWrapper, MobileTableWrapper } from './styles';

const Table = ({ method, results }) => (
  <TableContainer>
    <DesktopTableWrapper>
      <thead>
        <tr>
          {Object.entries(results[method]).map(([key, result]) => (
            <th key={key} colSpan={result.colspan}>
              {result.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {Object.values(results[method]).map(result =>
            Object.entries(result.secondRow).map(([key, label]) => <td key={key}>{label}</td>)
          )}
        </tr>
        <tr>
          {Object.values(results[method]).map(result =>
            Object.entries(result.values).map(([key, value]) => {
              if (result.label === 'Density') {
                return <DensityValues key={key}>{value}</DensityValues>;
              }
              return <td key={key}>{value}</td>;
            })
          )}
        </tr>
      </tbody>
    </DesktopTableWrapper>
    <MobileTableWrapper>
      <tbody>
        {Object.values(results[method]).map(result => {
          if (result.label === 'Density') {
            return (
              <tr key="density">
                <td>
                  <strong>Density</strong>
                </td>
                <DensityValues>
                  {result.values.pfc} {result.values.pfc !== '-' && <span>{result.units.pfc}</span>}
                  {result.values.kgm3} {result.values.kgm3 !== '-' && <span>{result.units.kgm3}</span>}
                </DensityValues>
              </tr>
            );
          }
          return Object.entries(result.secondRow).map(([key, label]) => {
            const mobileLabel = result.colspan === 1 ? result.label : label;

            return (
              <tr key={key}>
                <td>{mobileLabel}</td>
                <td>
                  {result.values[key]} {result.values[key] !== '-' ? result.units[key] : ''}
                </td>
              </tr>
            );
          });
        })}
      </tbody>
    </MobileTableWrapper>
    <Footer />
  </TableContainer>
);

/* eslint-disable react/forbid-prop-types */
Table.propTypes = {
  method: PropTypes.string.isRequired,
  results: PropTypes.shape({
    displacement: PropTypes.object.isRequired,
    caliper: PropTypes.object.isRequired,
  }).isRequired,
};
/* eslint-enable react/forbid-prop-types */

export default Table;
